import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APIClient } from "../../../api/apiCore";
import { useParams } from "react-router-dom";
import { generateInvoicePDF } from "../../../api";
import BeatLoader from "react-spinners/BeatLoader";

import { Button } from "react-bootstrap";

const ViewInvoicePDF: React.FC = () => {
  interface RowData {
    id: number;
    invoice_number: string;
    client: string;
    total_amount: string;
    created_at: string;
    due_date: string;
    isChecked?: boolean; // Checkbox state for each row
  }

  interface OptionType {
    label: string;
    value: string;
  }

  interface InvoiceItem {
    id: number | string;
    item?: string;
    service_product_number?: string;
    description?: string;
    qty?: string;
    invoice_type?: string;
    unit_type?: string | number | null;
    unit_price?: string;
    selected_date?: Date | null;
    vat_type?: OptionType | null;
    total_cost_net?: string | number;
    total_cost_gross?: string | number;
    is_add_discount?: boolean;
    discount_type?: string;
    discount_price?: string | number;
    discount_percentage?: string | number;
    discounted_total_price_net?: string | number;
    discounted_total_price_gross?: string | number;
  }

  interface InvoiceData {
    id: string;
    items?: InvoiceItem[];
    client: { client_name: string | null; id: string | null };
    invoice_date: Date | null;
    due_date: Date | null | undefined;
    invoice_number: string;
    po_number: string;
    isChecked?: boolean;
  }

  const navigate = useNavigate();
  const apiClient = new APIClient();
  const { id } = useParams();

  const [loading, setLoading] = useState<boolean>(false);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  useEffect(() => {
    const fetchInvoice = async () => {
      setLoading(true);
      try {
        const response = (await apiClient.get(
          "/api/invoice/generate-invoice-pdf/" + id,
          {},
          "blob",
        )) as Blob;
        const url = URL.createObjectURL(response);
        setLoading(false);
        setPdfUrl(url);
      } catch (error) {
        console.error("Error fetching invoice:", error);
        setLoading(false);
      }
    };

    fetchInvoice();
  }, []);

  const handleGoToSubscriptionPage = () => {
    navigate("/subscription");
  };

  return (
    <div className="right-panel">
      <div className="sticky-top bg-white shadow-sm w-100 p-3 d-flex justify-content-between align-items-center z-index-100">
        <span className="mb-0 default-text" style={{ fontWeight: "500" }}>
          E-Invoices
        </span>
        <Button variant="danger" onClick={handleGoToSubscriptionPage}>
          Unlock Pro
        </Button>
      </div>
      <div className="py-3  px-4">
        <div id="breadcrumb" className="d-flex gap-2 my-3">
          <i className="bx bx-home font-size-22"></i>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="flex-shrink-0 h-5 w-5"
            aria-hidden="true"
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
          <span>
            <a style={{ fontWeight: "500" }}> E-Invoices</a>
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="flex-shrink-0 h-5 w-5"
            aria-hidden="true"
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
          <span>
            <a style={{ fontWeight: "500" }}> View Invoice PDF</a>
          </span>
        </div>
        {pdfUrl && !loading && (
          <iframe
            src={pdfUrl}
            style={{ width: "100%", height: "1000px", border: "none" }}
            className="pt-3"
          ></iframe>
        )}

        {!pdfUrl && loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "500px",
            }}
          >
            <BeatLoader color="gray" size={10} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewInvoicePDF;
